import { useRouter } from 'next/router'
import { Form, Button, Input, message } from 'antd'

const handleJumpByPath = (path: any) => {
  // const router = useRouter();
  location.href = path
}

const interceptors = (res: any) => {
  if (res?.code === 200 || res?.code === 201) {
    //todo
  } else if (res?.message) {
    message.destroy()
    message.error(res.message)
    console.log('error', res)
  }
}

export { handleJumpByPath, interceptors }
